import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { VALUES } from '../../data/staticContent';

const AboutContent = () => {
  const { t } = useLanguage();

  return (
    <>
      {/* ── Our Story ────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* Image */}
            <div className="col-lg-6 order-lg-2">
              <div className="img-portrait-frame">
                <img
                  src="/assets/images/756.jpg.jpeg"
                  alt="Chaitralee Foundation"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: 'inherit' }}
                />
                <div className="float-card-accent" style={{ position: 'absolute', top: '1.5rem', left: '1.5rem' }}>
                  <div className="float-quote-text">Est. 2024</div>
                </div>
              </div>
            </div>

            {/* Text */}
            <div className="col-lg-6 order-lg-1">
              <span className="eyebrow">
                <i className="bi bi-journal-heart me-2"></i>Our Foundation
              </span>
              <h2 className="section-title">{t('about.storyTitle')}</h2>
              <div className="divider-brand"></div>
              <p className="body-text">{t('about.story1')}</p>
              <p className="body-text">{t('about.story2')}</p>
              <p className="body-text">{t('about.story3')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Mission & Vision ─────────────────── */}
      <section className="section-pad-alt">
        <div className="container">
          <div className="row g-4">

            <div className="col-lg-6">
              <div className="mission-box h-100">
                <div className="mv-icon-wrap mv-icon-light">
                  <i className="bi bi-bullseye"></i>
                </div>
                <div className="mv-title-light">{t('about.missionTitle')}</div>
                <p className="mv-text-light">{t('about.missionText')}</p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="vision-box h-100">
                <div className="mv-icon-wrap mv-icon-dark">
                  <i className="bi bi-eye"></i>
                </div>
                <div className="mv-title-dark">{t('about.visionTitle')}</div>
                <p className="mv-text-dark">{t('about.visionText')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Values ───────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">{t('about.valuesTitle')}</h2>
            <div className="divider-brand-center"></div>
          </div>
          <div className="row g-4">
            {VALUES.map(({ key, icon, iconClass, cardClass }, i) => (
              <div className="col-lg-3 col-md-6" key={key}>
                <div className={`${cardClass} anim-fade-up anim-delay-${i + 1}`}>
                  <div className={`card-icon-wrap ${iconClass} mb-3`}
                    style={{ width: '48px', height: '48px', borderRadius: '12px', background: `${iconClass.includes('primary') ? 'rgba(139,34,82,0.12)' : iconClass.includes('secondary') ? 'rgba(212,137,58,0.12)' : iconClass.includes('accent') ? 'rgba(110,158,122,0.12)' : 'rgba(123,94,167,0.12)'}`, color: `${iconClass.includes('primary') ? 'var(--brand-primary)' : iconClass.includes('secondary') ? 'var(--brand-secondary)' : iconClass.includes('accent') ? 'var(--brand-accent)' : '#7B5EA7'}` }}
                  >
                    <i className={`bi ${icon}`}></i>
                  </div>
                  <div className="value-title">{t(`about.value${key}`)}</div>
                  <p className="cf-card-text">{t(`about.value${key}Desc`)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Publication ──────────────────────── */}
      <section className="section-pad-alt">
        <div className="container">
          <div className="row align-items-center g-5 p-lg-4 p-3 rounded-4 bg-card border border-site">

            {/* Book mockup */}
            <div className="col-lg-4 col-md-5 text-center">
              <div className="book-cover-mockup">
                <div className="book-cover-inner">
                  <div className="book-title-text">Chitralee's book</div>
                  <div className="book-title-line"></div>
                  <div className="book-subtitle-text">A tribute to Chaitralee Indore</div>
                  <i className="bi bi-book mt-3" style={{ fontSize: '2rem', color: 'rgba(253,246,236,0.18)' }}></i>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="col-lg-8 col-md-7">
              <span className="eyebrow">
                <i className="bi bi-book me-2"></i>New Publication
              </span>
              <h2 className="section-title">{t('about.publicationTitle')}</h2>
              <div className="divider-brand"></div>
              <p className="body-text">{t('about.publicationText')}</p>
              <div className="d-flex flex-wrap gap-3">
                <a
                  href="https://www.chaitraleefoundationpune.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-brand"
                >
                  <i className="bi bi-globe"></i> {t('home.bookCta')}
                </a>
                <Link to="/who-is-chaitralee" className="btn-accent">
                  {t('common.learnMore')} <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default AboutContent;
